const quoteArray1 = [
  `"When something is truly important to you, be relentless in its pursuit."`,
  `"I'm a fast learner, if I had a 'super-power' it would be the ability to focus."`,
  `"A frustrating experience can be reframed into a progression opportunity."`,
]

export default quoteArray1;
